import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Shield, User, Users, Heart } from "lucide-react";
import { Button } from "../components/ui/button";

const roles = [
  {
    id: "coach",
    title: "Тренер",
    description: "Управление расписанием и командой",
    icon: Shield,
    color: "#1E4E3D"
  },
  {
    id: "athlete",
    title: "Спортсмен",
    description: "Отслеживание тренировок и статистики",
    icon: User,
    color: "#007AFF"
  },
  {
    id: "parent",
    title: "Родитель",
    description: "Наблюдение за прогрессом ребенка",
    icon: Heart,
    color: "#FF9500"
  },
  {
    id: "amateur",
    title: "Любитель",
    description: "Участие в общении команды",
    icon: Users,
    color: "#34C759"
  }
];

export default function RoleSelectionPage() {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState(null);

  const handleContinue = () => {
    if (selectedRole) {
      navigate("/register", { state: { role: selectedRole } });
    }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="role-selection-page">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-gray-100/50 px-4 py-4">
        <div className="flex items-center">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className="mr-2 rounded-full"
            data-testid="back-btn"
          >
            <ChevronLeft className="w-6 h-6" />
          </Button>
          <h1 className="font-heading text-xl font-semibold">Выберите роль</h1>
        </div>
      </header>

      {/* Content */}
      <div className="px-6 py-8">
        <p className="text-apple-text-secondary mb-8 text-center">
          Выберите вашу роль в команде
        </p>

        {/* Role Cards */}
        <div className="space-y-4 mb-8">
          {roles.map((role) => {
            const Icon = role.icon;
            const isSelected = selectedRole === role.id;
            
            return (
              <button
                key={role.id}
                onClick={() => setSelectedRole(role.id)}
                className={`role-card w-full p-5 rounded-2xl border-2 transition-all text-left flex items-center gap-4 ${
                  isSelected 
                    ? "border-golf-green bg-golf-green/5" 
                    : "border-gray-100 bg-white hover:border-gray-200"
                }`}
                data-testid={`role-${role.id}`}
              >
                <div 
                  className="w-14 h-14 rounded-2xl flex items-center justify-center"
                  style={{ backgroundColor: `${role.color}15` }}
                >
                  <Icon 
                    className="w-7 h-7" 
                    style={{ color: role.color }}
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-semibold text-lg text-black">
                    {role.title}
                  </h3>
                  <p className="text-apple-text-secondary text-sm">
                    {role.description}
                  </p>
                </div>
                <div 
                  className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${
                    isSelected 
                      ? "border-golf-green bg-golf-green" 
                      : "border-gray-300"
                  }`}
                >
                  {isSelected && (
                    <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        {/* Continue Button */}
        <Button
          onClick={handleContinue}
          disabled={!selectedRole}
          className={`w-full h-14 rounded-full text-lg font-semibold transition-all ${
            selectedRole 
              ? "bg-golf-green hover:bg-golf-green-hover text-white" 
              : "bg-gray-200 text-gray-400 cursor-not-allowed"
          }`}
          data-testid="continue-btn"
        >
          Продолжить
        </Button>
      </div>
    </div>
  );
}
